import React from 'react'
import { Box } from '@mui/material'
import Warning from 'components/molecules/Warning/Warning'
import ParValueModal from './update-par-value-modal/UpdateParValueModal'
import Header from 'components/molecules/Header/Header'
import DetailsModal from './details-modal/DetailsModal'
import InventoryTable from './InventoryTable/InventoryTable'
import StickyFilters from './InventoryFilters/StickyFilters/StickyFilters'
import useLogic from './InventoryReport.logic'
import { InventoryReportProvider } from './InventoryReportProvider'
import './InventoryReport.scss'

const Report = () => {
  const {
    assets,
    originalAssets,
    totalCount,
    isLoadingReport,
    reportError,
    paginationModel,
    handlePaginationModelChange,
    sortModel,
    handleSortModelChange,
    filters,
    handleFiltersChange,
    goBack,
    goForward,
    canGoBack,
    canGoForward,
    resetFilters,
    handleDownload,
    handleUpdateParValue,
    isLoadingUpdateParValue,
  } = useLogic()

  if (reportError) {
    return (
      <Box className="inventory-report-container">
        <Header parent="Reports" title="Products Inventory" />
        <Box className="error-container">
          <Warning
            type="warning"
            text="There was an error loading the inventory data. Please try again."
          />
        </Box>
      </Box>
    )
  }

  return (
    <Box className="inventory-report-container">
      <Header parent="Reports" title="Products Inventory" />
      <Box className="content-wrapper">
        <StickyFilters
          filters={filters}
          onFiltersChange={handleFiltersChange}
          assets={originalAssets}
          goBack={goBack}
          goForward={goForward}
          canGoBack={canGoBack()}
          canGoForward={canGoForward()}
          onReset={resetFilters}
          handleDownload={handleDownload}
          totalCount={totalCount}
        />
        <InventoryTable
          assets={assets}
          isLoading={isLoadingReport}
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          sortModel={sortModel}
          onSortModelChange={handleSortModelChange}
        />
      </Box>

      <DetailsModal />
      <ParValueModal
        onChange={handleUpdateParValue}
        isLoading={isLoadingUpdateParValue}
      />
    </Box>
  )
}

const InventoryReport = () => (
  <InventoryReportProvider>
    <Report />
  </InventoryReportProvider>
)

export default InventoryReport
